/* eslint-disable no-unused-vars */
import React, { useRef, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { formatDateMoment,capitalizeWords,convertToUpperCase } from '../../../utils/utils';
import { selectedSubjectData } from "../../slices/help"
import { useSelector } from 'react-redux';

const ReprintComponent = ({ open, onClose, printData, patientInfo, bagCount, onPrint }) => {
 const printContentRef = useRef(null);
 const checkDataApheresis = useSelector(selectedSubjectData);
 const topLevel = printData?.printPatientInfo?.patient_information?.print_details?.find((it) => it?.label_type == '8')
  const LeftLogo = topLevel?.brand_logo; 
  const brand_name = topLevel?.brand_name; 
  const org_name = topLevel?.org_name; 
 const reactToPrintFn = useReactToPrint({
     content: () => printContentRef.current,
     onAfterPrint: onClose,
     removeAfterPrint: true,
   });

     useEffect(() => {
       if (open) {
         const timer = setTimeout(() => {
           if (printContentRef.current) {
             reactToPrintFn();
           }
         }, 300);
         
         return () => clearTimeout(timer);
       }
     }, [open]);
  // Helper function to get initials
  const getInitials = (name) => {
    if (!name) return '';
    return name.split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Helper function to calculate age
  const calculateAge = (dob) => {
    if (!dob) return '';
    const birthDate = moment(dob);
    const today = moment();
    const years = today.diff(birthDate, 'years');
    return `${years} years`;
  };

  // Render all print copies
  const renderPrintContent = () => {
    if (!printData || bagCount === 0) {
      return null;
    }

    const patientDetails = printData.printPatientInfo?.patient_information || {};
    const batchInfo = printData.printPatientInfo || {};
    const apheresisDate = checkDataApheresis?.feasibility_apheresis_date || printData.apheresisDate || {};
    return (
      <div style={{ 
        width: '142mm',
        height: '142mm',
        padding: '0',
        margin: '0',
        fontFamily: 'Arial, sans-serif',
        fontSize: '11px'
      }}>
        {Array.from({ length: printData?.cryo ? 1 : bagCount }, (_, i) => i + 1).map((bagNumber) => (
          <div 
            key={`bag-${bagNumber}`}
            style={{
               width: '141mm',
              height: '141mm',
              border: '1px solid #000',
              boxSizing: 'border-box',
              backgroundColor: 'white',
              borderRadius:"5px",
              pageBreakAfter: 'always'
            }}
          >
            {/* HEADER - Centered */}
<div
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '2px',
    gap: '8px',
  }}
>
  {/* Left: logo + ImmunoACT */}
  <div style={{height:'60px', display: 'flex', alignItems: 'center', gap: '100px', paddingLeft:'5.5mm' }}>
    <img
      src={LeftLogo}
      alt="Logo"
      style={{maxHeight:'50px', maxWidth:'100px', objectFit: 'contain', display: 'block'}}
    />
      <div className='text-lg' style={{ fontWeight: 'bold',  letterSpacing: '0.5px',paddingTop:"15px",paddingRight:"15px" }}>
        {brand_name}

      </div>
      {/* optional small subtitle below ImmunoACT; remove if not needed */}
      {/* <div style={{ fontSize: '9px' }}>Tagline or subtitle</div> */}
  </div>

  {/* Right: note text */}
  <div className='text-lg' style={{ textAlign: 'right', fontWeight: 600, paddingRight:'5.5mm' }}>
       {printData?.printPatientInfo?.patient_information?.org_name}
  </div>
</div>
            {/* Divider line */}
            <hr style={{ border: 'none', borderTop: '1px solid #000', margin: '6px 0' }} />

            {/* Centered title */}
            <div className='text-base' style={{ 
              textAlign: 'center', 
              fontWeight: 'bold', 
              marginBottom: '6px',
            }}>
          {org_name}
            </div>

            {/* Divider line */}
            <hr style={{ border: 'none', borderTop: '1px solid #000', margin: '6px 0' }} />

            {/* Main content table - Full width */}
            <table width="100%" cellPadding="0" cellSpacing="0" className='text-base'>
              <tr>
                <td style={{ verticalAlign: 'top' }}>
                  <table width="100%" cellPadding="2" cellSpacing="0" style={{marginLeft: "4mm"}}>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Patient ID:</strong> {patientDetails.patient_id || '-'}
                      </td>
                     
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Patient Name:</strong> {capitalizeWords(patientDetails.name) || '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Patient Initials:</strong> {getInitials(convertToUpperCase(patientDetails.name)) || '-'}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingBottom: '1px' }}>
                        <strong>Patient DOB:</strong> {patientDetails.dob ? formatDateMoment(patientDetails.dob) : '-'}
                      </td>
                      <td style={{ paddingBottom: '1px', textAlign: 'right', paddingRight: "40px" }}>
                        <strong>Age:</strong> {calculateAge(patientDetails.dob)}
                      </td>
                    </tr>
                      <tr>
                       <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Patient weight (Kg):</strong> {patientDetails.body_weight ? `${patientDetails.body_weight}` : '-'}
                      </td>
                    </tr>
                     <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Patient Weight Submitted:</strong> {formatDateMoment(patientDetails?.inbound_updated_at)}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Disease Indications:</strong> {patientDetails.disease || '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Date of Apheresis:</strong> {apheresisDate ? moment(apheresisDate).format('DD/MM/YYYY') : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Hospital Name:</strong> {patientDetails.hospital || '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Batch Number:</strong> {batchInfo.batch_no || '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>CD3+ cell count(x10⁶ Cells):</strong> {printData?.bagData?.cd3_count}
                      </td>
                    </tr>
                    <tr>
                      <td width="50%" style={{ paddingBottom: '1px' }}>
                        <strong>Volume(ml):</strong> {printData?.bagData?.volume}
                      </td>
                       <td width="50%" style={{ paddingBottom: '1px', textAlign: 'right', paddingRight: "40px" }}>
                        <strong>BagNo:</strong>{printData?.cryo ? printData?.bagData?.identifier+'/'+printData?.bagCount: bagNumber+'/'+bagCount}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" style={{ paddingBottom: '1px' }}>
                        <strong>Date of Freezing:</strong> {printData?.bagData?.created_at ? formatDateMoment(printData?.bagData?.created_at) : '-'}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <strong>Ship and Store at:</strong> {printData.patientMedicalInfo?.['Ship & Store'] || '≤ -80 degrees'}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        ))}
      </div>
    );
  };

  return (
     <div style={{ display: 'none' }}>
      <div ref={printContentRef}>
          {renderPrintContent()}
        </div>
      </div>
  );
};

export default ReprintComponent;